import React, {Component} from "react";
import {Button} from "react-bootstrap";
import {getDistance} from "geolib";

export default class AddBoardCompliance extends Component{
    state = {
        compliance :{},
    }

    handleInputChange(event) {
        this.setState({fieldInput: event.target.value});
    }

    addCompliance(){
        let compliance = this.state.compliance
        if(this.validCompliance(compliance)){
            let board = this.props.board;
            compliance.lat = parseFloat(compliance.lat);
            compliance.lon = parseFloat(compliance.lon);
            compliance.distance = getDistance(
                {latitude:compliance.lat,longitude: compliance.lon},
                {latitude:board.lat,longitude:board.lon}
            )
            board.complianceArray.push(compliance);
            this.props.updateBoard(board);
        }
        this.setState({compliance: {name:"",lat:"",lon:"",category:""}})
    }
    validCompliance(compliance){
        return !!(compliance && compliance.lat && compliance.lon && compliance.name && compliance.category);
    }
    render(){
        return <div className="compliance-issue-container">
            <div className="compliance-left">
                <div className="compliance-name w-75"><input className={"w-100"} placeholder={"Name"} value={this.state.compliance.name} onChange={(ev)=>{
                    let compliance = this.state.compliance;
                    compliance.name = ev.target.value;
                    this.setState({compliance: compliance});
                }}/></div>
                <div className="compliance-category"><input placeholder={"Category"} value={this.state.compliance.category}
                                                            onChange={(ev)=>{
                                                                let compliance = this.state.compliance;
                                                                compliance.category = ev.target.value;
                                                                this.setState({compliance: compliance});
                                                            }}/></div>
            </div>
            <div className="compliance-distance">
                <input type={"number"} placeholder={"Lat"} value={this.state.compliance.lat} onChange={(ev)=>{
                    let compliance = this.state.compliance;
                    compliance.lat = ev.target.value;
                    this.setState({compliance: compliance});
                }}/>
                <input type={"number"} placeholder={"Lon"} value={this.state.compliance.lon} onChange={(ev)=>{
                    let compliance = this.state.compliance;
                    compliance.lon = ev.target.value;
                    this.setState({compliance: compliance});
                }}/>
            </div>
            <div className={"text-center"}>
                <Button onClick={()=>this.addCompliance()} disabled={!this.validCompliance(this.state.compliance)} className={"btn-sm"} variant={"primary"}>
                    + Add
                </Button>
            </div>
        </div>
    }
}
